//  ----------      START   IMPORT  BLOCK       ----------
import { useState } from 'react';
import { Form, Button, Card, Alert, Spinner } from 'react-bootstrap';
import { useLanguage } from '../../../../../API/Context/LanguageContext';
// Assuming you have a VocabContact file
import { VocabButtons } from '../../../../../ConfigFiles/multilingual/VocabButtons';
import { VocabSocials } from '../../../../../ConfigFiles/multilingual/VocabSocials';
//  ----------      END   IMPORT  BLOCK       ----------

const ContactWidget = () => {
  const { lan } = useLanguage();
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState({ loading: false, success: false, error: null });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, success: false, error: null });

    try {
      // Logic for API call would go here
      console.log("Sending data to API:", formData);
      // await ContactService.sendMessage(formData);
      
      setStatus({ loading: false, success: true, error: null });
      setFormData({ name: '', email: '', message: '' }); // Clear form
    } catch (err) {
      setStatus({ loading: false, success: false, error: "Failed to send message." });
    }
  };

  return (
    <Card className="shadow-sm border-0 p-3" style={{ borderRadius: '16px' }}>
      <Card.Body>
        {status.success && <Alert variant="success">{VocabSocials.message_success[lan]}</Alert>}
        {status.error && <Alert variant="danger">{status.error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>{VocabSocials.name[lan]}</Form.Label>
            <Form.Control 
              type="text" 
              required 
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{VocabSocials.email[lan]}</Form.Label>
            <Form.Control 
              type="email" 
              required 
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{VocabSocials.message[lan]}</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={4} 
              required 
              value={formData.message}
              onChange={(e) => setFormData({...formData, message: e.target.value})}
            />
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100" disabled={status.loading}>
            {status.loading ? <Spinner size="sm" /> : VocabButtons.send[lan]}
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ContactWidget;